import {
  UseMutateAsyncFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { GET_SHIPMENT_LIST, MAKE_DELIVERY_REQUEST } from "@/constants/Query";
import { apiRequest } from "@/utils/apiRequest";
import { AxiosResponse } from "axios";
import { IDeliveryRequest } from "@/types/apiResponse.types";
import { toast } from "react-toastify";
import { TMakeShipmentRequestDataUz } from "@/types/apiParam.types";

export const useMakeDeliverytRequest = (): UseMutateAsyncFunction<
  AxiosResponse<{ data: IDeliveryRequest }>,
  Error,
  TMakeShipmentRequestDataUz,
  unknown
> => {
  const queryClient = useQueryClient();

  const { mutateAsync: makeDeliveryRequest } = useMutation({
    mutationFn: (values: TMakeShipmentRequestDataUz) =>
      apiRequest(MAKE_DELIVERY_REQUEST, "put", values),
    onSuccess: () => {
      toast.success("Delivery requested successfully", {
        position: "top-center",
      });
      queryClient.invalidateQueries({
        queryKey: [GET_SHIPMENT_LIST],
        exact: false,
      });
    },
    onError: (error) => {
      toast.error(
        //@ts-ignore
        error?.response?.data?.error?.message || "Error occured",
        {
          position: "top-center",
        },
      );
    },
  });
  return makeDeliveryRequest;
};
